module.exports = __webpack_public_path__ + "img/teac_tn4d_player.f1e0dd13.png";